import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {autobind} from 'core-decorators';
import classNames from 'classnames';

export default class Select extends Component {
    static propTypes = {
        options: ImmutablePropTypes.list.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        clearable: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        value: undefined,
        placeholder: undefined,
        clearable: false,
        disabled: false,
        onChange: undefined,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.options !== this.props.options
            || nextProps.value !== this.props.value
            || nextProps.placeholder !== this.props.placeholder
            || nextProps.disabled !== this.props.disabled
            || nextProps.onChange !== this.props.onChange;
    }

    getSelectedIndex() {
        const {options, value} = this.props;
        return options.findIndex(option => option.get('value') === value);
    }

    @autobind
    handleChange(event) {
        const index = event.target.value;
        if (this.props.onChange) {
            if (!index) this.props.onChange('');
            else this.props.onChange(this.props.options.getIn([index, 'value']));
        }
    }

    renderValue() {
        const selectedIndex = this.getSelectedIndex();
        const selectedOption = selectedIndex >= 0 && this.props.options.get(selectedIndex);
        if (!selectedOption && this.props.placeholder) return this.props.placeholder;
        return selectedOption && selectedOption.get('label');
    }

    render() {
        const {options, placeholder, disabled} = this.props;
        const selectedIndex = this.getSelectedIndex();

        return (
            <div className={classNames('cielo24-vwrap-form-select', {'cielo24-vwrap-disabled': disabled})}>
                <select
                    value={selectedIndex}
                    disabled={disabled}
                    onChange={this.handleChange}
                >
                    {selectedIndex === -1 && <option value=''>{placeholder || 'Select an option'}</option>}
                    {selectedIndex >= 0 && this.props.clearable && <option value=''>{placeholder}</option>}
                    {options.map((option, index) => (
                        <option key={option.get('value')} value={String(index)}>
                            {option.get('label')}
                        </option>
                    ))}
                </select>
                <div className='cielo24-vwrap-value'>
                    {this.renderValue()}</div>
                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-chevron-down' aria-hidden={true} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/forms/select.js